module.exports = __webpack_public_path__ + "img/red-ribbon.46c3f26b.svg";